import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import config from "../../component/config";
import crypto from "crypto-js";
import { currencyFormat } from "../../component/component";
import PaymentDetails from "../component/payment-details";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { InputLabel } from "../../component/form-control";

const formatDate = (date) => moment(new Date(date)).format("MMM-DD-YYYY");

const BillingLabel = ({ label, text, _class }) => (
  <div className={`form-group ${_class}`}>
    <label className="small">{label}</label>
    <label className="form-control border-0">
      <strong>{text}</strong>
    </label>
  </div>
);

const RealProperty = (props) => {
  const [data, setData] = useState({});
  const [billingDetails, setBillingDetails] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    const data = sessionStorage.getItem("data");
    if (data) {
      const billing = crypto.AES.decrypt(data, config.secretKey).toString(
        crypto.enc.Utf8
      );

      const json = JSON.parse(billing);
      setData(json);
      setBillingDetails(json.billingDetails);
    } else {
      navigate("/home");
    }
  }, []);

  const goBack = () => navigate("/payment");

  return (
    <>
      <div className="max-w-5xl border rounded-lg mx-auto p-5 mb-20">
        <div className="text-orange-500 mb-2 border-b pb-2 font-bold">
          Billing Summary
        </div>
        <div className="grid grid-cols-3 gap-y-1.5 mb-5">
          <InputLabel label="Tax Payer's Name" value={data.name} />
          <InputLabel label="Type" value={"Miscellaneous"} />
          <InputLabel label="Billing Number" value={data.bill_no} />
          <InputLabel label="Billing Date" value={data.bill_date} />
          <InputLabel label="Validity" value={data.validity} />
          <InputLabel
            label="Total Amount"
            value={currencyFormat(data.total_amount)}
          />
          <InputLabel label="Remarks" value={data.remarks} />
        </div>

        <div className="text-orange-500 mb-2 border-b pb-2 font-bold">
          Billing Details
        </div>
        <table className="w-full text-xs">
          <thead className="text-center bg-green-700 text-white">
            <tr>
              <td rowSpan="2" className="p-2 border">
                ARP / PIN / Actual Use
              </td>
              <td rowSpan="2" className="p-2 border">
                Tax Year
              </td>
              <td colSpan="4" className="p-2 border">
                Basic
              </td>
              <td colSpan="4" className="p-2 border">
                SEF
              </td>
              <td colSpan="3" className="p-2 border">
                EPMC
              </td>
              <td rowSpan="2" className="p-2 border">
                Total
              </td>
            </tr>
            <tr className="">
              <td className="p-2 border">Tax</td>
              <td className="p-2 border">Pen</td>
              <td className="p-2 border">Disc</td>
              <td className="p-2 border">Total</td>
              <td className="p-2 border">Tax</td>
              <td className="p-2 border">Pen</td>
              <td className="p-2 border">Disc</td>
              <td className="p-2 border">Total</td>
              <td className="p-2 border">Tax</td>
              <td className="p-2 border">Pen</td>
              <td className="p-2 border">Total</td>
            </tr>
          </thead>
          <tbody>
            {billingDetails &&
              billingDetails.map((row, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 1 && "bg-gray-100"
                  } hover:bg-gray-300 text-right`}
                >
                  <td className="p-2 border text-left">
                    <div>{row.arp}</div>
                    <em className="text-gray-400">{row.pin}</em>
                    <br />
                    <em className="text-gray-400">
                      {row.kind}-{row.au}
                    </em>
                  </td>
                  <td className="p-2 border">
                    {row.year} {row.qtr_from}-{row.qtr_to}
                  </td>
                  <td className="p-2 border">
                    {currencyFormat(row.basic_tax)}
                  </td>
                  <td className="p-2 border">
                    {currencyFormat(row.basic_penalty)}
                  </td>
                  <td className="p-2 border">
                    {currencyFormat(row.basic_discount)}
                  </td>
                  <td className="p-2 border">{currencyFormat(row.basic)}</td>

                  <td className="p-2 border">{currencyFormat(row.sef_tax)}</td>
                  <td className="p-2 border">
                    {currencyFormat(row.sef_penalty)}
                  </td>
                  <td className="p-2 border">
                    {currencyFormat(row.sef_discount)}
                  </td>
                  <td className="p-2 border">{currencyFormat(row.sef)}</td>

                  <td className="p-2 border">{currencyFormat(row.epmc_tax)}</td>
                  <td className="p-2 border">
                    {currencyFormat(row.epmc_penalty)}
                  </td>
                  <td className="p-2 border">{currencyFormat(row.epmc)}</td>

                  <td className="p-2 border font-bold">
                    {currencyFormat(row.total)}
                  </td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr className="text-right">
              <th colSpan="13" className="p-2 border">
                Grand Total
              </th>
              <td className="text-orange-700 font-bold text-lg p-2 border">
                {billingDetails &&
                  currencyFormat(
                    billingDetails.reduce((a, b) => a + b.total, 0)
                  )}
              </td>
            </tr>
          </tfoot>
        </table>

        <div className="px-5 border bg-gray-50">
          <PaymentDetails type="rpt" />
        </div>

        <button
          type="button"
          className="flex bg-red-700 border text-white rounded mx-auto m-2"
          onClick={goBack}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
            />
          </svg>{" "}
          Back
        </button>
      </div>
    </>
  );
};

export default RealProperty;
